export default "__VITE_ASSET__u24g5qld__"